module.exports = __webpack_public_path__ + "media/images/companies/pia-ea1b42c06daa3fd38f3d774da306edaa.jpg";